var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 2.68832L35.5245 6.4858L40.0159 4.9186C42.1594 4.17115 44.4345 5.48149 44.9217 7.67556L46.062 12.6699L50.7282 13.5571C52.9747 13.9809 54.3099 16.2453 53.5913 18.462L52.0996 23.3001L55.7087 26.4115C57.393 27.8661 57.4324 30.489 55.8117 32.0002L52.0142 35.5245L53.5813 40.0157C54.3287 42.159 53.0185 44.4343 50.8244 44.9215L45.83 46.062L44.9429 50.728C44.5192 52.974 42.2553 54.3101 40.0379 53.5914L35.1998 52.0995L32.0885 55.7086C30.6332 57.3936 28.0119 57.4315 26.4998 55.8116L22.9754 52.0141L18.4843 53.5813C16.341 54.3288 14.0657 53.0186 13.5784 50.8245L12.4379 45.8298L7.77185 44.9427C5.52522 44.5188 4.18994 42.2546 4.90862 40.0378L6.40047 35.1997L2.79138 32.0884C1.10641 30.6331 1.0685 28.0119 2.68839 26.4997L6.48575 22.9753L4.91866 18.4841C4.1711 16.3407 5.48156 14.0655 7.67562 13.5783L12.6701 12.4379L13.5572 7.77178C13.9811 5.52526 16.2454 4.18999 18.4622 4.90856L23.3002 6.40041L26.4115 2.79131C27.8634 1.11018 30.4866 1.06494 32.0003 2.68832Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5446 13.4369C23.1262 12.0128 26.0932 11.2014 29.25 11.2014C39.2182 11.2014 47.299 19.2822 47.299 29.2502C47.299 39.2183 39.2182 47.2991 29.25 47.2991C19.282 47.2991 11.2012 39.2183 11.2012 29.2502C11.2012 26.0937 12.0122 23.1267 13.4364 20.5455",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2338 26.2419C24.8906 26.2419 26.2419 24.8906 26.2419 23.2338C26.2419 21.577 24.8906 20.2257 23.2338 20.2257C21.5769 20.2257 20.2256 21.577 20.2256 23.2338C20.2256 24.8906 21.5769 26.2419 23.2338 26.2419Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2664 38.2744C36.9231 38.2744 38.2744 36.9231 38.2744 35.2662C38.2744 33.6095 36.9231 32.2582 35.2664 32.2582C33.6095 32.2582 32.2582 33.6095 32.2582 35.2662C32.2582 36.9231 33.6095 38.2744 35.2664 38.2744Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2338 35.2664L35.2664 23.2338",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.487 16.488L16.4878 16.4873",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.0fabe1e05c9565e8d3c5913daacf66c2.svg";
export { ForwardRef as ReactComponent };